import QuotesEntityDetail from './quotes-entity-detail';
import RequireAuth from '@converge/ui/domain/auth/require-auth';

export const QuotesEntityDetailPage = () => {
  return (
    <RequireAuth>
      <QuotesEntityDetail />
    </RequireAuth>
  );
};

export default QuotesEntityDetailPage;
